import { styled } from '@linaria/react'

export const orderedListStyles = `
  counter-reset: custom-counter;
`

export const OrderedList = styled.ol`
  ${orderedListStyles}
`
